import React, { useState } from 'react';
import FadeReveal from './FadeReveal';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email';
    }
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    } else if (formData.message.trim().length < 10) {
      newErrors.message = 'Message must be at least 10 characters';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      const response = await fetch('https://formspree.io/f/xvgloevl', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        setSubmitSuccess(true);
        setFormData({ name: '', email: '', message: '' });
        setTimeout(() => setSubmitSuccess(false), 5000);
      } else {
        alert('There was an error sending your message. Please try again.');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      alert('There was an error sending your message. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact">
      <div className="shell">
        <div className="contact-layout">
          <div className="contact-aside">
            <FadeReveal direction="up">
              <div className="section-head" style={{ marginBottom: '1.5rem' }}>
                <span className="eyebrow">Get in touch</span>
                <h2>Let's build<br />something.</h2>
                <p className="lead">
                  I'm actively looking for internship and entry-level opportunities.
                  Hiring, collaborating, or just want to talk tech? Say hello.
                </p>
              </div>

              <div className="contact-methods">
                <a
                  className="contact-card"
                  href="mailto:alex.cristea.laur2004@gmail.com"
                  aria-label="Send me an email"
                >
                  <span>Email</span>
                  <strong>alex.cristea.laur2004@gmail.com</strong>
                </a>
                <a
                  className="contact-card"
                  href="https://www.linkedin.com/in/laur-alexandru-cristea-24b867312/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Connect on LinkedIn"
                >
                  <span>LinkedIn</span>
                  <strong>Laur-Alexandru Cristea</strong>
                </a>
                <div className="contact-card">
                  <span>Location</span>
                  <strong>Timișoara, Romania</strong>
                </div>
              </div>
            </FadeReveal>
          </div>

          <FadeReveal direction="up" delay={0.1}>
            <form
              className="contact-form"
              onSubmit={handleSubmit}
              noValidate
              aria-busy={isSubmitting}
              aria-label="Contact form"
            >
              <div className="field">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your name"
                  required
                  aria-describedby={errors.name ? 'name-error' : undefined}
                  aria-invalid={!!errors.name}
                />
                {errors.name && (
                  <span id="name-error" className="form-error" role="alert">{errors.name}</span>
                )}
              </div>

              <div className="field">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="hello@example.com"
                  required
                  aria-describedby={errors.email ? 'email-error' : undefined}
                  aria-invalid={!!errors.email}
                />
                {errors.email && (
                  <span id="email-error" className="form-error" role="alert">{errors.email}</span>
                )}
              </div>

              <div className="field">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell me about your project or opportunity…"
                  required
                  aria-describedby={errors.message ? 'message-error' : undefined}
                  aria-invalid={!!errors.message}
                />
                {errors.message && (
                  <span id="message-error" className="form-error" role="alert">{errors.message}</span>
                )}
              </div>

              <button type="submit" className="btn btn--solid" disabled={isSubmitting}>
                {isSubmitting ? 'Sending…' : 'Send message'}
              </button>

              {submitSuccess && (
                <div className="form-success" role="status" aria-live="polite">
                  ✓ Message sent! I'll get back to you soon.
                </div>
              )}
            </form>
          </FadeReveal>
        </div>
      </div>
    </section>
  );
};

export default Contact;
